/**
 * Dialog Component
 */
export * from './dialog';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-popups/src/dialog/index.js
// module id = 1838
// module chunks = 0